// ** React Imports
import { Fragment, useState } from 'react'
// ** Reactstrap Imports
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap'

const TabsBasic = ({Form,Form2,Form3}) => {
  // ** State
  const [active, setActive] = useState('1')

  const toggle = tab => {
    if (active !== tab) {
      setActive(tab)
    }
  }
  return (
    <>
      <Nav tabs className='mx-auto'>
        <NavItem>
          <NavLink
            active={active === '1'}
            onClick={() => {
              toggle('1')
            }}
          >
            Tab1
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            active={active === '2'}
            onClick={() => {
              toggle('2')
            }}
          >
            Level of  configuration
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            active={active === '3'}
            onClick={() => {
              toggle('3')
            }}
          >
            Set sub position exit levels
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent className='py-50' activeTab={active}>
        <TabPane tabId='1'>
          {Form}
        </TabPane>
        <TabPane tabId='2'>
       <div className="d-flex justify-content-around">
       {/* <h1>Levels</h1> <h1>Quantity Multiplier </h1> */}
       </div>
        {Form2}
        </TabPane>
        <TabPane tabId='3'>
        {Form3}
        </TabPane>
      </TabContent>
    </>
  )
}
export default TabsBasic
